import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import httpsImageSrc from '../../assets/images/subscription/https.png';
import discoverImageSrc from '../../assets/images/subscription/discover.png';
import jcbImageSrc from '../../assets/images/subscription/jcb.png';
import maestroImageSrc from '../../assets/images/subscription/maestro.png';
import payPalImageSrc from '../../assets/images/subscription/pay-pal.png';
import mastercardImageSrc from '../../assets/images/subscription/mastercard.png';
import unionpayImageSrc from '../../assets/images/subscription/unionpay.png';
import visaImageSrc from '../../assets/images/subscription/visa.png';
import amexImageSrc from '../../assets/images/subscription/americanexpress.png';
import styles from './PaymentInformationBlock.css';

const cx = classnames.bind(styles);

function PaymentInformationBlock({
    className,
    label = 'PAY safe & secure'
}) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <div className={classes}>
            <div className={styles.safeBlock}>
                <Icon name='lock' />
                <span>{label}</span>
            </div>
            <ul className={styles.list}>
                <li>
                    <img
                        alt='https'
                        src={httpsImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='discover'
                        src={discoverImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='jcb'
                        src={jcbImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='maestro'
                        src={maestroImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='payPal'
                        src={payPalImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='unionpay'
                        src={unionpayImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='visa'
                        src={visaImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='american express'
                        src={amexImageSrc}
                    />
                </li>
                <li>
                    <img
                        alt='mastercard'
                        src={mastercardImageSrc}
                    />
                </li>
            </ul>
        </div>
    );
}

PaymentInformationBlock.propTypes = {
    className: PropTypes.string
};

PaymentInformationBlock.defaultProps = {
    className: ''
};

export {
    PaymentInformationBlock
};
